import UserDesc from "./UserDesc";
import UserDetails from "./UserDetails";

const LoanwiseUsers = () => {
  return (
    <section>
      <UserDesc />
      <UserDetails />
    </section>
  );
};

export default LoanwiseUsers;
